import { parseMultipleFiles } from '../files/parseMultipleFiles';

const parseLotUpdateFiles = lotsFiles => ({
  ...parseMultipleFiles(lotsFiles.multipleFiles, file => file.fileToUpload),
  ...lotsFiles.files,
});

export { parseLotUpdateFiles, parseMultipleFiles };
